import React from 'react';

import Radio from '@material-ui/core/Radio';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import { UiButton } from '../../../ui/ui-button';

import { ContactType } from './contact-type';
import { hasDataDiscrepancy } from './has-data-discrepancy';

import { employeeNameFromSimpleContact } from '../../../employees/utils/employee-name';
import { ICON_NAMES, MaterialDesignIcon } from '../../../util/material-design-icons';

type InputProps = {
  importId: number;
  resolution: PartiallyMatchingContactResolution;
  existingContact: PartiallyMatchingSimpleContact;
  importedData: EmployeeDirectoryImportSimpleContact;
  handleRadioButtonSelected: (
    importId: number,
    existingContact: PartiallyMatchingSimpleContact,
    contactId: number,
    createNewEntry: boolean,
  ) => () => void;
  handleResolveDiscrepancy: (
    importId: number,
    importedData: EmployeeDirectoryImportSimpleContact,
    existingContact: PartiallyMatchingSimpleContact,
  ) => () => void;
  clearResolution: (importId: number) => () => void;
  includeTableRow: boolean;
};

export const MatchingContactRow = ({
  importId,
  resolution,
  existingContact,
  importedData,
  includeTableRow,
  handleRadioButtonSelected,
  handleResolveDiscrepancy,
  clearResolution,
}: InputProps) => {
  const Wrapper = includeTableRow ? TableRow : React.Fragment;
  return (
    <Wrapper>
      <TableCell>
        <div className="u-flex-center">
          <Radio
            checked={resolution.selectedContactId === existingContact.contactId}
            onChange={handleRadioButtonSelected(
              importId,
              existingContact,
              existingContact.contactId,
              false,
            )}
            value="a"
          />
          <ContactType context={existingContact} />
        </div>
      </TableCell>
      <TableCell>{employeeNameFromSimpleContact(existingContact)}</TableCell>
      <TableCell>
        {resolution.selectedContactId === existingContact.contactId ? (
          <div className="u-flex-center">
            {hasDataDiscrepancy(existingContact, importedData) && !resolution.conflictResolution ? (
              <UiButton
                size="xs"
                onClick={handleResolveDiscrepancy(importId, importedData, existingContact)}
              >
                <MaterialDesignIcon iconName={ICON_NAMES.CLOSE} size="sm" />{' '}
                <span className="u-padding-left-sm">Resolve</span>
              </UiButton>
            ) : (
              <MaterialDesignIcon iconName={ICON_NAMES.CHECK_CIRCLE} />
            )}
            {resolution.conflictResolution ? (
              <UiButton size="xxs" variant="tertiary" onClick={clearResolution(importId)}>
                Undo
              </UiButton>
            ) : (
              ''
            )}
          </div>
        ) : null}
      </TableCell>
    </Wrapper>
  );
};
